import React from "react"
import { listing, listingStyle } from "./listing.module.css"

const Listing = ({ children }) => {
    return <p className={listing}><code className={listingStyle}>{children}</code></p>
}

export default Listing
